// extracted by css-extract-rspack-plugin
export default {"root":"NavGroup_root__20BuL","name":"NavGroup_name__M7sDd","draggable":"NavGroup_draggable__0FH21"};